import {
  Component,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Input,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  Inject,
  PLATFORM_ID,
} from '@angular/core'
import { AddCoboPayload, LoanInfo, OfferInfo, PayOfferObject } from '../../../core/helpers/interfaces'
import { HttpClient } from '@angular/common/http'
import { LayoutService } from '../../../core/services/layout.service'
import moment from 'moment'
import { Observable } from 'rxjs'
import {
  jsonPartiallyApproved,
  getLoanInfoCleanTemp,
  jsonDeclinedCoboOffer,
  jsonFullyApproved1Option,
  jsonFullyApproved2Options,
  jsonPartiallyApproved3Options,
  requestFullyApproved,
  jsonDeclinedCoboOfferCreditFreeze,
  jsonWelcomeBackScreen,
} from 'src/app/core/helpers/loanInfoUtils'
import { ApiService } from 'src/app/core/services/api.service'
import {
  emailErrorMessage,
  mobileErrorMessage,
  sendAppLinkSuccessMessage,
  validateEmail,
  validateNumber,
} from 'src/app/core/helpers/app-link'
import { LoanOptionsService } from 'src/app/core/services/loan-options.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { ModalTypes } from 'src/app/core/helpers/modal-store'
import { NGXLogger } from 'ngx-logger'
import { environment } from 'src/environments/environment'
import { SendAppLinkService } from 'src/app/core/services/send-app-link.service'
import { OptionsStore, topNamings } from './options-utils/options-store'
import { RequestHandler } from './options-utils/request-handler'
import { OptionsLogic } from './options-utils/options-logic'
import { ModalOptionsNavigation } from './options-utils/modal-navigation'
import { UserStateService, UserStateType } from 'src/app/core/services/user-state.service'
import { ModalOptionsMainComponent } from './modal-options-main/modal-options-main.component'
import { GlobalErrorHandler } from '../../../GlobalErrorHandler'
import { BlockerService } from 'src/app/modules/account/services/blocker.service'
import { DentistService } from 'src/app/core/services/dentist.service'
import { ModalPopupsService } from './modal-popups.service'
import { SelectedDentistInfo } from 'src/app/modules/account/shared/models/home-data'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { ModalOptionsStraightDeclineComponent } from './modal-options-straight-decline/modal-options-straight-decline.component'
import { ModalOptionsLoanSelectComponent } from './modal-options-loan-select/modal-options-loan-select.component'
import { InvalidStatePopupComponent } from './popups/invalid-state/invalid-state.component'
import { isPlatformBrowser } from '@angular/common'

export interface ApiResponceI {
  timestamp: number
  data: any
  errors: []
}

@Component({
    selector: 'app-modal-options',
    templateUrl: './modal-options.component.html',
    styleUrls: ['./modal-options.component.scss'],
    standalone: false
    //imports: [ModalOptionsStraightDeclineComponent, ModalOptionsLoanSelectComponent, InvalidStatePopupComponent]
})
export class ModalOptionsComponent implements OnInit {
  showDentistHeader
  @Output() closeModal: EventEmitter<any> = new EventEmitter()
  @Input() hooverPopupText = ''
  breakpoints: any = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }

  public equipmentProviderInActive: boolean = false
  public store: OptionsStore
  public backStore: OptionsStore
  public requestHandler: RequestHandler
  public logic: OptionsLogic
  public navigation: ModalOptionsNavigation
  private selectedDentistData: SelectedDentistInfo

  @ViewChild(ModalOptionsMainComponent) mainForm: ModalOptionsMainComponent

  constructor(
    private eRef: ElementRef,
    private http: HttpClient,
    public userStateService: UserStateService,
    private layoutService: LayoutService,
    private loanOptionsService: LoanOptionsService,
    public pageNavigationService: PageNavigationService,
    public modalStateService: ModalStateService,
     @Inject(PLATFORM_ID) private platformId: object,
    // private notifier: NotifierService,
    private cdr: ChangeDetectorRef,
    public errorHandler: GlobalErrorHandler,
    public logger: NGXLogger,
    public sendAppLinkService: SendAppLinkService,
    private api: ApiService,
    private _blocker: BlockerService,
    private dentist: DentistService,
    private modalPopups: ModalPopupsService,
    public sharedDataService: SharedDataService
  ) {
    this.store = new OptionsStore()
    this.navigation = new ModalOptionsNavigation(this.store, this.breakpoints, this.logger, this.cdr)
    this.requestHandler = new RequestHandler(
      this.store,
      this.navigation,
      this.api,
      this.pageNavigationService,
      this.modalStateService,
      this.loanOptionsService,
      this.sendAppLinkService,
      // this.notifier,
      this.errorHandler,
      this.breakpoints,
      this.logger,
      this._blocker
    )
    this.logic = new OptionsLogic(this.store, this.requestHandler, this.navigation)

    this.layoutService.subscribeToLayoutChanges().subscribe(
      (observerResponse) => {
        this.breakpoints = this.layoutService.handleLayoutChanges()
      },
      (error: any) => {
        console.error(error)
      }
    )

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeModal.emit()
      }
    })
    // document.addEventListener('selectionchange', (event) => {
    //   this.notifier.notify('success', JSON.stringify(event.currentTarget))
    //   this.notifier.notify('success', (event.currentTarget === event.target).toString())
    // })
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    if(this.equipmentProviderInActive){
      document?.documentElement?.style?.setProperty('--background-color', '#0072BC')
    } else {
      document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
    }
  }

  ngOnInit() {
    this.api.getGlobalVars().subscribe(t => {
      let data = t.data
      // data = data.filter(t => t.configName === "loan_min_amount" || t.configName === "loan_max_amount")
      // console.log(data)
      this.modalPopups.createLoanValue(data.filter(t => t.configName === "loan_min_amount")[0].configValue, data.filter(t => t.configName === "loan_max_amount")[0].configValue)
    })
    this.logger.info('init modal')
    const isRestored = this.logic.checkAndRestoreModal()
    if (!isRestored) {
      this.logic.checkAndRestoreExternal()
    }
  }

  toggleLoader(bool?: boolean) {
    this.logger.debug(`set loader: ${bool}`)
    if (bool === undefined) {
      this.store.loading = !this.store.loading
    } else {
      this.store.loading = bool
    }
    this.cdr.detectChanges()
  }

  public closeModalEvent(e) {
    // this.notifier.hideAll()
    this.closeModal.emit()
  }

  public showErrorScreen() {
    this.backStore = Object.assign({}, this.store)
    this.navigation.setOffAnyState()
    // console.log('saved!')
    // console.log(this.backStore)
    this.store.showErrorScreen = true
  }
  public closeErrorScreen() {
    this.store = Object.assign(this.store, this.backStore)
    // console.log('restored!')
    // console.log(this.store)
    this.store.showErrorScreen = false
  }

  public unlockCreditFreeze(data) {
    this.logger.info(data)
    // this.collectLoanResponseInfo(obj, data)
    this.requestHandler.sendLoanRequest(data.data)
    this.toggleLoader(false)
  }

  // click out of modalWrapper
  @HostListener('document:click', ['$event'])
  public clickout(event) {
    // console.log('modal option clickout')
    if (this.store.loading) {
      return
    }
    try {
      const modalOptions = this.eRef.nativeElement
      if (!modalOptions.contains(event.target)) {
        return
      }
      const childrenOfRef = modalOptions.children
      if (childrenOfRef.length === 0 || childrenOfRef[0].length === 0) {
        return
      }
      const modalWrapper = childrenOfRef[0].children[0]
      // clicked outside
      if (!modalWrapper.contains(event.target)) {
        this.closeModal.emit()
      }
    } catch (err) {
      this.logger.error(err)
    }
  }

  private async getConsents() {
    try {
      const consNames = [
        'Terms Of Use',
        'Credit Profile Authorization',
        'Electronic Communications Act Agreement',
        'Privacy Policy',
      ]

      const res: any = await this.api.getConsentCodes().toPromise()
      // console.log(res)
      if (res?.resultMap?.consents) {
        const codes = res?.resultMap?.consents
          .filter((x) => consNames.includes(x.description))
          .map((x) => x.shortCode)
        return codes
      }
    } catch (err) {
      this.logger.error(err)
    }
    return null
  }

  /**
   * check state
   * @param state object
   * @returns promise of boolean
   */

  /**
   * show tooltip if state is not available
   * @param obj - { info: LoanInfo, coapp: boolean }
   */
  private enableInvalidState(obj: { info: LoanInfo; coapp: boolean }) {
    // TODO: show different screen
    this.logger.warn(`${obj.info.address.state} is not an available state`)
    this.toggleLoader(false)
    this.userStateService.isInvalidState = true
    setTimeout(()=>{
      this.userStateService.isInvalidState = false
    }, 5000)
    this.userStateService.type = UserStateType.state
    // TODO: send to form message to set invalid address
    this.mainForm.notifyFormSetInvalidAddressCauseState()
    this.cdr.detectChanges()
  }

  private lessStateAmount() {
    // TODO: show different screen
    this.toggleLoader(false)
    this.userStateService.isInvalidStateAmount = true
    setTimeout(()=>{
      this.userStateService.isInvalidStateAmount = false
    }, 5000)
    this.userStateService.type = UserStateType.lessStateAmount
    // TODO: send to form message to set invalid address
    // this.mainForm.notifyFormSetInvalidAddressCauseState()
    // this.cdr.detectChanges()
  }
  private lessMinAmount() {
    // TODO: show different screen
    this.toggleLoader(false)
    this.userStateService.isInvalidStateAmount = true
    setTimeout(()=>{
      this.userStateService.isInvalidStateAmount = false
    }, 5000)
    this.userStateService.type = UserStateType.minLoanAmount
    // TODO: send to form message to set invalid address
    // this.mainForm.notifyFormSetInvalidAddressCauseState()
    // this.cdr.detectChanges()
  }
  private moreMaxAmount() {
    // TODO: show different screen
    this.toggleLoader(false)
    this.userStateService.isInvalidStateAmount = true
    setTimeout(()=>{
      this.userStateService.isInvalidStateAmount = false
    }, 5000)
    this.userStateService.type = UserStateType.maxLoanAmount
    // TODO: send to form message to set invalid address
    // this.mainForm.notifyFormSetInvalidAddressCauseState()
    // this.cdr.detectChanges()
  }

  public async onSubmitEvent(obj: { info: LoanInfo; coapp: boolean }) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.store.coapp = obj.coapp
    // let testObj = JSON.parse("{\r\n    \"address\": {      \"address1\": \"1 WAVEY WILLOW LN\",\r\n        \"address2\": \"\",\r\n        \"city\": \"MONTGOMERY\",\r\n        \"state\": \"NY\",\r\n        \"zipCode\": \"12549\"\r\n    },\r\n    \"annualIncome\": 60000,\r\n    \"authorizeText\": true,\r\n    \"coboRequestId\": 0,\r\n    \"consentIds\": [\r\n        \"TOU\",\r\n        \"ECC\",\r\n        \"PP\",\r\n        \"CPA\"\r\n    ],\r\n   \"amount\": \"2500\",\r\n    \"dateOfBirth\": \"10/01/1988\",\r\n    \"firstName\": \"LYNN\",\r\n    \"lastName\": \"MAURITZSON\",\r\n    \"mobile\": \"8482460698\",\r\n    \"ssn\": \"666024250\",\r\n    \"channelId\": \"iOS\",\r\n    \"extFaSessionId\": \"{{extFaSessionId}}\",\r\n    \"blackBox\": \"Test blackbox\",\r\n    \"deviceLatitude\": 40.542292464,\r\n    \"deviceLongitude\": -74.372681583\r\n}")
    navigator.geolocation.getCurrentPosition((position) => {
      if (position) {
        this.dentist.userCoords = {deviceLatitude: position.coords.latitude, deviceLongitude: position.coords.longitude}
        let newObj = Object.assign({}, obj.info, this.dentist.userCoords);
        obj.info = newObj
      }
    },
      (error) => console.log(error));
      // obj.info = testObj
    const codes = await this.getConsents()
    if (codes) {
      obj.info.consentIds = codes
    }
    if (obj.info.extFaSessionId) {
      this.store.extFaSessionId = obj.info.extFaSessionId
    }
    this.requestHandler.collectLoanRequestInfo(obj)
    const devStatus: any = document.getElementById('devSubStatus')
    if (devStatus?.value === 'AS_STATE') {
      devStatus.value = ''
      obj.info.address.state = 'AS'
    }
    // this.api.getConsultationInfo().subscribe(t => console.log(t))
    // return
      // this.navigation.setShowSelectBlock()
    // return
    if (this.store.FULL_DEV && devStatus?.value !== '' && !obj?.coapp) {
      this.toggleLoader(true)
      // dev props only:
      this.store.subStatusOnlyDev = true
      this.store.loanInfo = obj.info
      this.store.loanInfo.amount = 2500
      const newResData = this.requestHandler.sendLoanRequest(null)
      this.requestHandler.collectLoanResponseInfo(obj, { data: newResData })
      this.logger.info('offersInfo:')
      this.logger.info(this.store.offersInfo)
      this.cdr.detectChanges()
      return
    }
    this.toggleLoader(true)
    this.requestHandler.collectLoanRequestInfo(obj)
    this.store.loanInfo = obj.info
    const isStateAv = await this.modalPopups.isStateAvailable(obj.info.address.state)
    if (!obj.coapp) {
      // const isStateAv = await this.isStateAvailable(obj.info.address.state)
      if (!isStateAv) {
        this.enableInvalidState(obj)
        return
      }
      let val = obj.info.amount ? +obj.info.amount.toString().replace('$','').replace(',','') : undefined
      if(isStateAv.minRequestedAmt){
        this.modalPopups.changeValue(isStateAv.minRequestedAmt, "HI")
        // let val = obj.info.amount ? +obj.info.amount.toString().replace('$','').replace(',','') : undefine
      if (isStateAv.minRequestedAmt > val) {
        this.lessStateAmount()
        return
      }
      }
      if (+this.modalPopups.loanMinValue > +val){
        this.lessMinAmount()
        return
      }
      if (+this.modalPopups.loanMaxValue < +val){
        this.moreMaxAmount()
        return
      }
    }
    this.userStateService.isInvalidStateAmount = false
    this.userStateService.isInvalidState = false
    if(this.selectedDentistData){
      let newObj = Object.assign({}, this.selectedDentistData, obj.info)
      this.requestHandler
      .getLoanQuote(newObj, obj.coapp)
      .toPromise()
      .then(
        (res: ApiResponceI) => {
            this.toggleLoader(false)
            this.logger.info(res)
            this.requestHandler.collectLoanResponseInfo(obj, res)
            this.requestHandler.sendLoanRequest(res.data)
        },
        (err) => {
          this.toggleLoader(false)
          this.requestHandler.errorHandler(err, this)
        }
      )
    } else {
    this.api.getPhoneConsult(obj.info.mobile).subscribe((t)=>{
      if(!t.consultationId){
        this.navigation.setShowSelectDentistBlock()
        this.toggleLoader(false)
        return
      }
      obj.info.consultationUuid = t.consultationId
      this.requestHandler
      .getLoanQuote(obj.info, obj.coapp)
      .toPromise()
      .then(
        (res: ApiResponceI) => {
            this.toggleLoader(false)
            this.logger.info(res)
            this.requestHandler.collectLoanResponseInfo(obj, res)
            this.requestHandler.sendLoanRequest(res.data)
        },
        (err) => {
          this.toggleLoader(false)
          this.requestHandler.errorHandler(err, this)
        }
      )
      // this.navigation.setShowSelectBlock()
    },(err) => {
      this.navigation.setShowSelectDentistBlock()
      this.toggleLoader(false)
      // this.navigation.setShowSelectBlock()
    })}
    // await this.requestHandler
    //   .getLoanQuote(obj.info, obj.coapp)
    //   .toPromise()
    //   .then(
    //     (res: ApiResponceI) => {
    //         this.toggleLoader(false)
    //         this.logger.info(res)
    //         this.requestHandler.collectLoanResponseInfo(obj, res)
    //         this.requestHandler.sendLoanRequest(res.data)
    //     },
    //     (err) => {
    //       this.toggleLoader(false)
    //       this.requestHandler.errorHandler(err, this)
    //     }
    //   )
  }

  public calcTopNamingClass() {
    if (this.store.showCoapplicant) {
      return 'padding-header-modal-text'
    }
    // single naming on select
    if (this.store.showSelectBlock && this.breakpoints.extraSmall) {
      return 'topNamingSpacingSingle'
    }
    // single naming on fully_approved
    if (this.store.showOffer && this.breakpoints.extraSmall) {
      return 'topNamingSpacingSingle'
    }
    // single naming on straight_declined
    if (this.store.showDecline && this.breakpoints.extraSmall) {
      return 'topNamingSpacingSingle'
    }
    // single naming on credit lock
    if (this.store.showCreditLock && this.breakpoints.extraSmall) {
      return 'topNamingSpacingSingle'
    }
    // single naming on aaa
    if (this.store.showErrorScreen && this.breakpoints.extraSmall) {
      return 'topNamingSpacingSingle'
    }
    if (this.store.showPartnerDown && this.breakpoints.extraSmall) {
      return 'topNamingSpacingSingle'
    }
    return ''
  }

  public sendAppLink(event: any): void {
    if (typeof event === 'object') {
      const body = {
        loanAcctId: event.loanAcctId || '',
        phone: event.phone || '',
        emailAddress: event.emailAddress || '',
        cobo: event.cobo || undefined,
      }
      this.toggleLoader(true)
      this.sendAppLinkService.sendAppLinkObjWrapper(body, this)
    }
    if (typeof event === 'string') {
      this.logic.sendAppLinkNumber(event, this)
    }
  }

  /**
   * used to show success screen after 200 code send app link
   * @param event - screens output
   */
  public sendAppLinkAndShowSuccess(event: any): void {
    const body = {
      loanAcctId: event.loanAcctId || '',
      phone: event.phone || '',
      emailAddress: event.emailAddress || '',
      cobo: event.cobo || undefined,
    }
    this.toggleLoader(true)

    this.api
      .sendAppLinkObj(body)
      .toPromise()
      .then(
        (data) => {
          this.logger.info(data)
          this.store.showSuccess = true
          this.store.topNaming = topNamings.DEFAULT
          this.store.showOffer = false
          this.store.showCoapplicant = false

          this.toggleLoader(false)
          this.cdr.detectChanges()
        },
        (error: any) => {
          console.error(error)
          const errs = { status: error.status, error: error.error }
          // this.notifier.notify('error', JSON.stringify(errs))
          this.toggleLoader(false)
          this.cdr.detectChanges()
        }
      )
  }

  /**
   * partial approved -> show select block -> add coapp
   */
  public showSelectEvent(event) {
    this.navigation.setShowSelectBlock()
  }

  public sendAppLinkEmail(obj: { mail: string; loanAcctId?: string; cobo?: boolean }) {
    this.logger.info(obj.mail)
    if (!validateEmail(obj.mail)) {
      this.logger.info('send notify')
      // this.notifier.notify('error', emailErrorMessage)
      return
    }
    this.toggleLoader(true)
    this.sendAppLinkService.sendAppLinkWrapper(obj.loanAcctId, null, obj.mail, obj.cobo, this)
    this.cdr.detectChanges()
  }

  public onCloseModalClick() {
    this.closeModal.emit()
    this.store.topNaming = topNamings.DEFAULT
    this.modalStateService.pushToLocalStorage('modalType', null)
  }

  public onOfferInfo(e: OfferInfo) {
    // console.log(e)
    // skip request if all by substatus
    if (this.store.subStatusOnlyDev) {
      this.store.selectedOfferInfo = e
      this.store.showSelectBlock = false

      if (this.store.isPartialApproved) {
        this.store.showCoapplicant = true
      } else {
        this.store.showOffer = true
      }
      // this.store.loading = false
      return
      
    }

    this.logger.info(e)
    this.toggleLoader(true)
    this.cdr.detectChanges()
    this.requestHandler
      .loanOptionSelection(e)
      .toPromise()
      .then(
        (data) => {
          this.store.selectedOfferInfo = e
          this.store.showSelectBlock = false
          if (this.store.isPartialApproved) {
            this.store.showCoapplicant = true
          } else {
            this.store.showOffer = true
          }
          this.toggleLoader(false)
          this.logger.info(data)
          this.cdr.detectChanges()
          // this.notifier.notify('success', JSON.stringify(data))
        },
        (error: any) => {
          this.toggleLoader(false)
          console.error(error)
          const errs = { status: error.status, error: error.error }
          this.cdr.detectChanges()
          // this.notifier.notify('error', JSON.stringify(errs))
        }
      )
  }
  public selectDentist(e: SelectedDentistInfo){
    let initObj = {info: this.store.loanInfo, coapp: this.store.coapp}
    if (e) { 
      let newObj = Object.assign({}, e, this.store.loanInfo)
      this.requestHandler
      .getLoanQuote(newObj, this.store.coapp)
      .toPromise()
      .then(
        (res: ApiResponceI) => {
            // this.toggleLoader(false)
            this.logger.info(res)
            this.requestHandler.collectLoanResponseInfo(initObj, res)
            this.requestHandler.sendLoanRequest(res.data)
        },
        (err) => {
          this.selectedDentistData = e
          this.store.showDentistSelect = false
          this.store.showMainBlock = true
          this.toggleLoader(false)
          this.requestHandler.errorHandler(err, this)
        }
      )
    } else {
      this.toggleLoader(true)
      this.store.showMainBlock = true
      this.store.showDentistSelect = false
      this.requestHandler
      .getLoanQuote(this.store.loanInfo, this.store.coapp)
      .toPromise()
      .then(
        (res: ApiResponceI) => {
          this.toggleLoader(false)
            // this.toggleLoader(false)
            this.logger.info(res)
            this.requestHandler.collectLoanResponseInfo(initObj, res)
            this.requestHandler.sendLoanRequest(res.data)
        },
        (err) => {
          this.store.showDentistSelect = false
          this.toggleLoader(false)
          this.store.showMainBlock = true
          this.requestHandler.errorHandler(err, this)
        }
      )
    }
  }
  showDentistTitle(e:boolean){
    this.showDentistHeader = e
    this.store.topNaming = e ? topNamings.SIMPLE_SEAMLESS : topNamings.DEFAULT
  }
  loadOffers(e){
    // console.log(this.store.nextStep)
    if (this.store.nextStep === 'Pre_LO_Max_Approved' || this.store.nextStep === 'Pre_LO_FA'){
    this.store.loading = true
    this.api.getLoanOptions(this.store.userId, this.store.loanId).subscribe((r) => {
          const data = r.data
          // this.store.offersInfo = r
          this.store.loanData = data
          this.store.loanAcctId = data.loanAcctId
          this.store.approvedLoanAmount = data.approvedLoanAmount
          this.store.maxApprovedLoanAmount = data.maxApprovedLoanAmount
          this.store.loanId = data.loanId
          this.store.offersInfo = data
          this.store.loading = false
          this.loanOptionsService.loanResponse = data
          this.navigation.setShowSelectBlock()
        }, () => this.store.loading = false)
      }
      if (this.store.nextStep === 'Pre_LO_PA_Decision') {
        this.store.loading = true
        this.api.getLoanOptions(this.store.userId, this.store.loanId).subscribe((r) => {
          const data = r.data
          this.store.loanData = data
          this.store.loanAcctId = data.loanAcctId
          this.store.approvedLoanAmount = data.approvedLoanAmount
          this.store.maxApprovedLoanAmount = data.maxApprovedLoanAmount
          this.store.loanId = data.loanId
          this.store.offersInfo = data
          this.store.loading = false
          this.loanOptionsService.loanResponse = data
          this.store.loanInfo.amount = data.requestedAmount
          this.navigation.setShowPartialApproved()
        }, () => this.store.loading = false)
      }
      if (this.store.nextStep === 'Pre_LO_None') {
        this.navigation.setShowDecline()
      }
      if (this.store.nextStep === 'Post_LA_Pend_Coffee_Cup') {
        this.navigation.setShowException()
      }
      if (this.store.nextStep === 'Pre_LO_Credit_Freeze') {
        this.requestHandler.showCreditLockClick(this.store.creditData)
        return true
      }
    this.store.showWelcomeBack = this.store.showWelcomeBackContinue = false
  }
  ngOnDestroy(): void{
    this.modalPopups.checkLoanOptionsEnteredData = null
  }
}
